<template>
  <label class="form-comment">
    <slot />

    <VText small v-html="value" />
  </label>
</template>

<script>
export default {
  name: 'VFormComment',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.form-comment {
  display: block;
}
</style>
